module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_11.f7565f79.jpg";